import { memo } from 'react';
import { HStack, Icon, Text } from '@chakra-ui/react';

import { useUpToDateFileAttribute } from '~/core/shared/hooks';
import { useRedactionDisplayConfig } from './hooks';
import { RedactionStatusPillProps } from './types';

const RedactionStatusPillComponent = ({
  file,
  fraudUpdates,
}: RedactionStatusPillProps) => {
  const updatedFileAttribute = useUpToDateFileAttribute(file, fraudUpdates);

  const config = useRedactionDisplayConfig(
    updatedFileAttribute?.redactionStatus,
  );

  return (
    <HStack
      bg={config.bgColor}
      borderRadius="full"
      gap={2}
      h={7}
      px={3}
      py={0}
      w="fit-content"
    >
      {config.icon && (
        <Icon as={config.icon} boxSize={5} color={config.iconColor} />
      )}
      <Text
        color={config.color}
        fontSize="xs"
        fontWeight="semibold"
        textTransform="uppercase"
        whiteSpace="nowrap"
      >
        {config.displayText}
      </Text>
    </HStack>
  );
};

export const RedactionStatusPill = memo(RedactionStatusPillComponent);
